<template>
    <el-row :loading="isBusy">
        <el-col :span="24">
            <h2>Payment Gateway</h2>
        </el-col>
        <el-col :span="24" v-if="initError" style="margin-top:20px">
            <el-alert type="error" show-icon title="Payment gate is unavailable." :closable="false">
                We encounter problem with payment gate. Please try again later or contact our support team.
            </el-alert>
        </el-col>
        <el-col :span="24" v-else-if="error !== ''" style="margin-top:20px">
            <el-alert type="error" show-icon title="We found problem with the selected payment method."
                      :closable="false">
                {{ error }}
            </el-alert>
            <el-button type="primary" style="margin-top:10px" @click="refreshPage">Try Again</el-button>
        </el-col>
        <el-col :span="24" v-else style="margin-top:20px" v-loading="isBusy">
            <template v-if="cardAdded">
                <el-alert type="success" title="Thank you!" :closable="false">
                    Thank you. Your card details were successfully saved.
                </el-alert>
                <el-button type="primary" style="margin-top:10px" @click="refreshPage">Check My Payment Methods</el-button>
            </template>
            <template v-else>
                <template v-if="creditCards.length > 0">
                    <h3>Existing Cards</h3>
                    <p>We already received this payment information:</p>
                    <el-table
                        :data="creditCards"
                        stripe
                        style="width:100%;margin-bottom:20px;">
                        <el-table-column
                            prop="number"
                            label="Card">
                        </el-table-column>
                        <el-table-column
                            prop="valid"
                            label="Valid">
                        </el-table-column>
                        <el-table-column
                            prop="is_default"
                            label="Set as primary">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.is_default === 'No'" size="mini" @click="setPrimary(scope.row.id)">Make primary</el-button>
                                <el-tag v-else type="success" size="small" disable-transitions>Primary</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <h3>New Card Details</h3>
                <p style="margin-bottom:20px">Input a new card information here:</p>
                <div ref="cardElement"></div>
                <el-button type="primary" style="margin-top:20px" @click="saveCard">Save Card</el-button>
            </template>
        </el-col>
    </el-row>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js/pure';

export default {
    props: {
        initError: { type: Boolean, required: true },
        clientSecret: { type: String, required: true },
        hash: { type: String, required: true },
        publicKey: { type: String, required: true },
        creditCards: { type: Array, required: true },
    },
    data() {
        return {
            isBusy: true,
            error: '',
            cardAdded: false,
            stripe: {},
            stripeCardElement: {},
        };
    },
    mounted() {
        const self = this;

        if (!self.initError) {
            loadStripe(self.publicKey).then((result) => {
                self.stripe = result;
                self.stripeCardElement = self.stripe.elements().create('card');
                self.stripeCardElement.mount(self.$refs.cardElement);
            }).catch(err => {
                self.initError = true;
            }).finally(() => {
                self.isBusy = false;
            });
        } else {
            self.isBusy = false;
        }
    },
    methods: {
        saveCard() {
            const self = this;
            self.isBusy = true;

            self.stripe.confirmCardSetup(
                self.clientSecret,
                { payment_method: { card: self.stripeCardElement } },
            ).then((result) => {
                // after card details were submitted to stripe
                if (result.error) {
                    self.error = result.error.message;
                    return true;
                }
                return false;
            }).then(isError => {
                // submission to stripe without error
                // set payment_method_added on customer in our DB
                if (!isError) {
                    return axios.post(
                        self.url(`payment-gateway/${self.hash}/save-card`),
                        { payment_method_added: 1 },
                    );
                }
                return false;
            }).then(success => {
                // success is false when there was an error in steps before
                if (success !== false) {
                    self.cardAdded = true;
                }
            }).catch(err => {
                self.error = 'We are sorry, but something went wrong. Please try again or contact our support team.';
            }).finally(() => {
                self.isBusy = false;
            });
        },
        refreshPage() {
            window.location.reload();
        },
        setPrimary(paymentMethodId) {
            const self = this;
            self.isBusy = true;
            const defaultError = 'Set primary payment method failed.';

            axios.post(
                self.url(`payment-gateway/${self.hash}/set-primary`),
                { method_id: paymentMethodId },
            ).then(result => {
                if (result.data.method_id === 'undefined') {
                    self.error = defaultError;
                } else {
                    self.creditCards.map((el) => {
                        el.is_default = el.id === result.data.method_id ? 'Yes' : 'No';
                        return el;
                    });
                }
            }).catch(err => {
                self.error = defaultError;
            }).finally(() => {
                self.isBusy = false;
            });
        },
    },
};
</script>

<style scoped>

</style>